<template>
  <div class="strategy-home">
    <Tabs
      v-if="false"
      :active="tabsActive"
      :listData="tabsData"
      @change="changeTabs"
    />
    <ActionBox
      :active="actionActive"
      :listData="actionOptions[tabsActive]"
      :messageTotal="messageTotal"
      @select="select"
    />
    <template v-if="listData && listData.length > 0">
      <List :listData="listData" @toDetail="toDetail" @stop="stop" @run="run" />
    </template>
    <template v-if="!(listData && listData.length > 0) && isLoading">
      <Empty description="暂无策略执行"></Empty>
    </template>
<!--    <p class="tips">暂无更多数据</p>-->
    <!--    全部停止弹窗 -->
    <van-dialog
      class="stop-dialog-wrap"
      v-model="isShowStopDialog"
      :show-cancel-button="true"
      confirm-button-text="确定"
      @confirm="confirmStop"
    >
      <StopDialog v-model="checkData"></StopDialog>
    </van-dialog>
    <expireDialog :dialogShow="dialogShow" :dataMsg="dataMsg" @update="handUpdate"></expireDialog>


  </div>
</template>

<script>
import Tabs from "./components/Tabs.vue";
import ActionBox from "./components/ActionBox.vue";
import List from "./components/List.vue";
import StopDialog from "./components/StopDialog.vue";
import { Dialog, Toast, Empty  } from "vant";
import { MESSAGE_PROMPT } from '@/utils/constants';
import expireDialog from "../expireDialog/index.vue";
export default {
  components: {
    expireDialog,
    Tabs,
    ActionBox,
    List,
    StopDialog,
    Empty,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      tabsActive: 1,
      tabsData: [
        { label: "按策略", value: 1 },
        { label: "按账号", value: 2 }
      ],
      actionActive: 0,
      actionOptions: {
        1: [],
        2: []
      },
      isLoading: false,
      listData: [],
      isShowStopDialog: false,
      checkData: {
        isClose: true,
        isCancel: true
      },
      messageTotal: 0,    // 消息条数
      dialogShow:false,
      dataMsg:''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.actionActive = this.$route.query.strategyId || 0;
      this.getStrategyNameList();
      this.getH5PageGetAccount();
      this.getPlanStatisticsList();
      this.getMessage();
    },
    changeTabs(e) {
      this.tabsActive = e.value;
    },
    // 获取策略类型
    getStrategyNameList() {
      this.$apis.strategyNamelist().then(res => {
        this.actionOptions["1"] = [];
        if (res.data.data) {
          this.actionOptions["1"] = res.data.data.map(item => {
            return {
              name: item.strategyName,
              value: item.strategyId,
              ...item
            };
          });
          this.actionOptions["1"].unshift({
            name: "全部策略",
            value: 0
          });
        }
      });
    },
    // 获取账户列表
    getH5PageGetAccount() {
      this.$apis
        .getGroupList({
          show_account: 2,
          is_empty_hide: 1
        })
        .then(res => {
          this.actionOptions["2"] = [];
          if (res && res.length > 0) {
            const _find = res.find(item => item.type == 1);
            if (_find) {
              this.actionOptions["2"] = _find.account_list.map(item => {
                return {
                  ...item,
                  name: `${item.futures_login_id}(${item.futures_name})`,
                  value: item.futures_login_id
                };
              });
            }
          }
        });
    },
    select({ action }) {
      this.actionActive = action.value;
      this.$router.push({
        path: this.$route.path,
        query: {
          strategyId: this.actionActive
        }
      }).catch();
    },
    toDetail(e) {
      this.$router.push({
        path: "/h5-strategy-execution",
        query: {
          strategyId: e.strategyId
        }
      });
    },
    run(e) {
      this.$apis
        .setStrategyStart({ strategy_id: e.strategyId, auto_id: 0 })
        .then((res) => {
          let msg = res.data.error_msg;
          if(res.data.error_code === 0 && res.data.error_msg == 'OK'){
            msg = "已提交全部运行申请，请关注运行状态"
            Toast(msg);
          }else{
            this.dialogShow = true
            this.dataMsg = res.data.error_msg
          }
          this.init();
        });
    },
    stop(e) {
      this.isShowStopDialog = true;
      this.checkData = {
        isClose: true,
        isCancel: true
      };
      this.stopItem = e; // 临时存储当前 item 数据，弹窗使用
    },
    confirmStop() {
      const params = {
        strategy_id: this.stopItem.strategyId,
        auto_id: 0,
        close: this.checkData.isClose ? 1 : 0,
        cancel: this.checkData.isCancel ? 1 : 0
      };
      this.$apis.setStrategyStop(params).then(res => {
        let msg = res.data.error_msg;
        if(res.data.error_code === 0){
          msg = "已提交全部停止申请，请关注运行状态"
        }
        Toast(msg);
        this.init();
      });
    },
    //
    getPlanStatisticsList() {
      clearTimeout(this.getPlanStatisticsListTimer);
      this.$apis
        .getPlanStatisticsListApi({
          size: 100,
          page: 1,
          strategy_id: this.actionActive
        })
        .then(res => {
          this.isLoading = true;
          if (res.data && res.data.data) {
            this.listData = res.data.data.planStatusNum || [];
          }
          this.getPlanStatisticsListTimer = setTimeout(() => {
            this.getPlanStatisticsList();
          }, 3000);
        });
    },
    // 请求获取消息接口
    async getMessage() {
      try {
        // 从localStorage中安全获取用户信息
        const user = this.safeParseStorageItem('h5userInfo');
        // 检查获取到的用户信息是否有效
        if (!user || !user.id) {
          throw new Error('User information not found or incomplete.');
        }
        const query = {
          userId: user.id.toString(),
          pageSize: 1,
          currentPage: 1,
          level: 0,
          isRead: 0,
          ...MESSAGE_PROMPT
        };
        const response = await this.$apis.getStationMessageListApi(query);
        // 检查响应是否有效
        if (response && typeof response === 'object' && 'total' in response) {
          this.messageTotal = response.total;
        }
      } catch (error) {
        
      }
    },
    // 解析localStorage中的数据
    safeParseStorageItem(key) {
      try {
        return JSON.parse(localStorage.getItem(key));
      } catch (e) {
        
        return null;
      }
    },
   // 关闭弹层
    handUpdate(e){
      if(e){
        this.dialogShow = false
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.getPlanStatisticsListTimer); // 离开页面关闭递归
  }
};
</script>

<style scoped lang="less">
.stop-dialog-wrap {
  border-radius: 8px;
  padding: 38px 40px 34px;
  width: 560px;
  color: #4a4a4a;
  /deep/ .van-hairline--top {
    &:after {
      border: none;
    }
  }
  /deep/ .van-button {
    border: none;
  }
  /deep/ .van-dialog__confirm,
  /deep/ .van-dialog__cancel {
    &:extend(.base-style .flex-center);
    width: 228px;
    height: 80px;
    font-size: 28px;
    font-weight: 500;
  }
  /deep/ .van-dialog__confirm {
    color: #fff;
    background: #1c0955;
  }
  /deep/ .van-dialog__cancel {
    color: #1c0955;
    border: 2px solid #1c0955;
    margin-right: 24px;
  }
}
.tips {
  color: #999;
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}
</style>
